import type { FC } from 'react';

import styles from './styles.module.scss';

interface OrderStatusTextProps {
  statusText: string;
}

export const OrderStatusText: FC<OrderStatusTextProps> = ({ statusText }) => {
  return (
    <div aria-live="polite">
      <p role="status" data-cy={'order-status-state'} className={styles.statusText}>
        {statusText}
      </p>
    </div>
  );
};
